import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class TemplatesToEmailsModel extends BaseModel {
  uuid = null;
  template_type = null;
  emails = [];

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    template_type: 'required',
    emails: 'required'
  };

  attributeLabels = {
    template_type: i18n.t('Template Type'),
    emails: i18n.t('Emails'),
  };
}
